import AppLoader from '@/components/AppLoader';
import { ROUTE_LOGIN } from '@/constants/routes';
import useAuth from '@/hooks/useAuth';
import useFirebase from '@/hooks/useFirebase';
import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';

export default function RequireAuth<Properties extends JSX.IntrinsicAttributes>(
	Component: React.ComponentType<Properties>
) {
	function AuthenticatedComponent(props: Properties) {
		const firebase = useFirebase();
		const auth = useAuth();
		const history = useHistory();

		/**
		 * If firebase is not ready just render a loader and wait
		 */
		if (!firebase.isFirebaseReady) {
			return <AppLoader />;
		}

		/**
		 * If we have a token but not authenticated it means we are "login-in"
		 */
		if (!auth.isAuthenticated && firebase.token) {
			return <AppLoader />;
		}

		/**
		 * If we are not authenticated at this point
		 * - Firebase is ready
		 * - We are not login in
		 *
		 * Check if authenticated, if not redirect to login.
		 */
		if (!auth.isAuthenticated) {
			const search = new URLSearchParams();
			search.set('redirect', history.location.pathname + window.location.search + window.location.hash);

			return (
				<Redirect
					to={{
						pathname: ROUTE_LOGIN,
						search: search.toString(),
					}}
				/>
			);
		}

		return <Component {...props} />;
	}

	Object.defineProperty(AuthenticatedComponent, 'name', {
		value: `Authenticated__${Component.name}__HOC`,
	});

	return AuthenticatedComponent;
}
